<template>
  <router-link
    :to="view.startLinkParams(doc)"
    class="continue-reading__item"
    @click.prevent="$emit('unitClick')"
  >
    <BookCardThumbnail
      :doc="doc"
      class="continue-reading__img-box"
      coverClass="continue-reading__img"
      fallbackCoverClass="continue-reading__img"
    />
    <div class="continue-reading__text-box">
      <div class="continue-reading__text">
        <h3 class="continue-reading__title card__title">{{ doc.title }}</h3>
        <h4 class="continue-reading__author">{{ doc.author }}</h4>
      </div>
      <div class="continue-reading__progress-box">
        <div class="continue-reading__progress">
          <div
            :aria-valuenow="doc.user.progress"
            aria-valuemin="0"
            aria-valuemax="100"
            class="continue-reading__progress-now"
            :class="`continue-reading__progress-now--${doc.user.progress}`"
          ></div>
        </div>
        <span class="continue-reading__progress-num"
          >{{ doc.user.progress }}%</span
        >
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import type { Book } from '@/models/interfaces'

import type { BooksView } from '@/models/doc.book'

import BookCardThumbnail from '@/app/components/book/card/BookCardThumbnail.vue'

defineProps<{
  doc: Book
  view: BooksView
}>()

defineEmits<{
  (e: 'unitClick'): void
}>()
</script>
